import Helpers from '@helpers';

const sliderTimer = {};
const activeSlideIndex = {};
const sliderCountdown = {};
let barInterval;

const initSlider = () => {

    $(document).ready(function () {
        $('.slider').each(function () {
            var slides = $(this).find('.slider-item');
            if (slides.length != 1) {
                $(this).find('.slidePlus').show();
                $(this).find('.slideMinus').show();
            }
        });
    });

    $('.slider-pointer').click(function() {
        ChangeSlide($(this).closest('.slider'), $(this).index(), true);
    });

    $('.slider').each(function() {
        ChangeSlide($(this));
    });

    $('.slidePlus').click(function () {
        let currentSlide = $('.slider-dot.active').index();
        const slides = $(this).closest('.slider').find('.slider-item');
        currentSlide += 1;
        if (currentSlide === slides.length) { currentSlide = 0 }
        ChangeSlide($(this).closest('.slider'), currentSlide, true);
    });

    $('.slideMinus').click(function () {
        let currentSlide = $('.slider-dot.active').index();
        const slides = $(this).closest('.slider').find('.slider-item');
        currentSlide -= 1;
        if (currentSlide === -1) { currentSlide = slides.length-1 }
        ChangeSlide($(this).closest('.slider'), currentSlide, true);
    });

    $('.p-slideMinus').click(function () {
        let currentSlide = $('.product-slider-text.active').index();
        const slides = $(this).closest('.slider').find('.slider-item');
        currentSlide += 1;
        if (currentSlide === slides.length) { currentSlide = 0 }
        ChangeSlide($(this).closest('.slider'), currentSlide, true);
    });

    $('.p-slidePlus').click(function () {
        let currentSlide = $('.product-slider-text.active').index();
        const slides = $(this).closest('.slider').find('.slider-item');
        currentSlide -= 1;
        if (currentSlide === -1) { currentSlide = slides.length - 1 }
        ChangeSlide($(this).closest('.slider'), currentSlide, true);
    });


};



function ChangeSlide(slider: JQuery<HTMLElement>, slideIndex: number = 0, manualChange: boolean = false) {

    if (slider.find('#sliderLoading').length != 0) {
        clearInterval(barInterval);
        let sliderTimeOut = Helpers.Utils.zeroIfEmpty(slider.attr('data-timeout'));
        loadingBar(sliderTimeOut / 1000);
    }

    if (!slider.data('slider-id')) {
        slider.data('slider-id', Math.floor((Math.random() * 1000000) + 1));
    }

    const sliderId = Helpers.Utils.zeroIfEmpty(slider.data('slider-id'));
    activeSlideIndex[sliderId] = slideIndex;

    const slides = slider.find('.slider-item');
    const pointers = slider.find('.slider-pointer');

    if (slides.length === 0) return;

    const activeSlide = slider.find('.slider-item:eq(' + slideIndex + ')');
    const activePointer = slider.find('.slider-pointer:eq(' + slideIndex + ')');

    // CHANGE POINTER
    $(pointers).removeClass('active');
    $(activePointer).addClass('active');

    // CHANGE IMAGE
    $(slides).not(activeSlide).addClass('hidden');
    $(activeSlide).removeClass('hidden');

    // SET SLIDE CHANGE INTERVAL
    if (manualChange) {
        clearInterval(sliderTimer[sliderId]);
        sliderTimer[sliderId] = null;
    }

    if (!sliderTimer[sliderId]) {
        let timeout = Helpers.Utils.zeroIfEmpty(slider.attr('data-timeout'));
        if (timeout === 0) {
            timeout = 7000;
        }

        sliderTimer[sliderId] = setInterval(() => {
            activeSlideIndex[sliderId]++;

            if (activeSlideIndex[sliderId] > (slides.length - 1)) {
                activeSlideIndex[sliderId] = 0;
            }
            ChangeSlide(slider, activeSlideIndex[sliderId]);
        }, timeout);
    }

    function loadingBar(time) {
        const bar = document.getElementById('loadingBar');
        bar.style.width = "1%";
        var width = 1;
        barInterval = setInterval(fram, 10);
        var upper = 100 * time;
        function fram() {
            if (width >= upper) {
                clearInterval(barInterval);
            } else {
                width++;
                bar.style.width = (width/time) + "%";
            }
        }
    }



    // SET COUNTER INTERVAL
    if (!sliderCountdown[sliderId]) {
        const entryTime = new Date();
        sliderCountdown[sliderId] = setInterval(() => {
            const currentSlide = slider.find('.slider-item').not('.hidden');

            const spanRemainingTime = currentSlide.find('.productItem-time');
            const divRemainingDays = currentSlide.find('.timer-day');
            const divPrice = currentSlide.find('.price-tag');

            const expireTimestamp = Helpers.Utils.zeroIfEmpty(currentSlide.attr('data-timestamp'));
            const currentTime = new Date();
            const passTime = (currentTime.getTime() - entryTime.getTime()) / 1000;
            const expireTimeSeconds = expireTimestamp / 1000;
            const remainingSeconds = (expireTimeSeconds - passTime) ;
            

            

            // EXPIRED SLIDER
            //if (remainingSeconds <= 0) {
            //    divPrice.hide();
            //    clearInterval(sliderCountdown[sliderId]);
            //    return;
            //}

            divPrice.show();
            const remainingTime = Helpers.Utils.secondsToTime(remainingSeconds);
            if (remainingTime.d > 0) {
                divRemainingDays.show();
                divRemainingDays.text(Helpers.Utils.ConvertToPersianDigit(remainingTime.d.toString()) + ' روز ');
            } else {
                divRemainingDays.hide();
            }
            var date = new Date(remainingSeconds * 1000);
            date.setMinutes(date.getMinutes() - 210);
            var hours = date.getHours();
            var minutes = "0" + date.getMinutes();
            var seconds = "0" + date.getSeconds();

            var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

            

            const remainingTimeText =
                Helpers.Utils.twoDigitNumber(remainingTime.h) + ':' +
                Helpers.Utils.twoDigitNumber(remainingTime.m) + ':' +
                Helpers.Utils.twoDigitNumber(remainingTime.s);

            spanRemainingTime.text(formattedTime);
        }, 1000);
    }
}

export {
    initSlider
};
